import { Component } from '@angular/core';

@Component({
    selector: 'az-root',
    template: '<router-outlet></router-outlet>',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'Guru Monarch Beach Resort';
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/app.component.ts